import { render, staticRenderFns } from "./ModelUpgrade.vue?vue&type=template&id=ca122afa&scoped=true"
import script from "./ModelUpgrade.vue?vue&type=script&lang=js"
export * from "./ModelUpgrade.vue?vue&type=script&lang=js"
import style0 from "./ModelUpgrade.vue?vue&type=style&index=0&id=ca122afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca122afa",
  null
  
)

export default component.exports